import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const PaymentTypeCellContent: React.FC<PaymentTypeCellContent.Props> = ({
	item,
	language,
}) => {
	const { t } = useTranslation();

	const { content, backgroundColor, textColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.PaymentType];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item, t);
	}, [item, language, t]);

	return (
		<CellContentRoot
			alignItems="center"
			h="100%"
			w="100%"
			backgroundColor={backgroundColor}
			textColor={textColor}
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace PaymentTypeCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default PaymentTypeCellContent;
